<template>
  <DSButton
    variant="ghost"
    size="sm"
    @click="expanded = !expanded"
  >
    {{ expanded ? 'Collapse all' : 'Expand all' }}
  </DSButton>
</template>

<script setup lang="ts">
import { DSButton } from '@ds'

const expanded = defineModel<boolean>('expanded', { default: false })
</script>
